export enum TermsAndConditionsTestHooks {
  CheckBox = 'direct-debit-terms-and-conditions-checkbox',
}
